import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LeftSidebar from './LeftSidebar';
import ChatSection from './ChatSection';
import RightSidebar from './RightSidebar';
import '../../../../styles/messages.css';
import '../../../../styles/responsive.css';
import { getBusinessUserList } from '../../Services/getBusinessUserList';
import { jwtDecode } from 'jwt-decode';

function Index({ setNotification, notification })
{
    const location = useLocation();
    const [activeConversation, setActiveConversation] = useState(null);
    const [conversationSearchId, setConversationSearchId] = useState(null);
    const [ChatSearching, setChatSearching] = useState(null);
    const [HomeUnreadMessages, setHomeUnreadMessages] = useState(0);
    const [unreadMessages, setUnreadMessages] = useState(null);
    const [homeData, setHomeData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [conversations, setConversations] = useState([]);
    const [isChatVisible, setIsChatVisible] = useState(false);

    const handleConversationClick = (conversationId) =>
    {
        setIsLoading(true);
        setActiveConversation(null);

        setTimeout(() =>
        {
            setActiveConversation(conversationId);
            setHomeData(conversationId);
            setIsLoading(false);
            setIsChatVisible(true);
        });
    };

    const handleBackToList = () => {
        setIsChatVisible(false);
        setActiveConversation(null);
    };

    useEffect(() => {
        const fetchConversations = async () => {
            const token = localStorage.getItem('token');
            if (token) {
                const decodeToken = jwtDecode(token);
                const homeUserId = decodeToken.nameid;
                const data = await getBusinessUserList(homeUserId);
                setConversations(data);

                // Check for conversationId from URL after conversations are loaded
                const params = new URLSearchParams(location.search);
                const conversationIdFromUrl = params.get('conversationId');
                if (conversationIdFromUrl) {
                    const conversationToActivate = data.find(c => c.conversationId === parseInt(conversationIdFromUrl));
                    if (conversationToActivate) {
                        handleConversationClick(conversationToActivate);
                    }
                }
            }
        };
        fetchConversations();
    }, [location.search]);

    return (
        <div>
            <div className="messaging-wrapper-main ">
                <div className="container-fluid px-4">
                    <div className={`messaging-inner-wrapper ${isChatVisible ? 'chat-visible' : ''}`}>

                        <div className="messaging-left">
                            <LeftSidebar
                                unreadMessages={HomeUnreadMessages}
                                setActiveConversation={handleConversationClick}
                                setHomeData={setHomeData}
                            />
                        </div>

                        <div className="messaging-center">
                            {isLoading ? (
                                <div className="loader">
                                    <div className="spinner"></div>
                                </div>
                            ) : (
                                <ChatSection
                                    setUnreadMessages={setHomeUnreadMessages}
                                    ChatSearching={ChatSearching}
                                    setConversationSearchId={setConversationSearchId}
                                    activeConversation={activeConversation}
                                    setNotification={setNotification}
                                    notification={notification}
                                    homeData={homeData}
                                    onBack={handleBackToList}
                                />
                            )}

                        </div>
                        <RightSidebar
                            setChatSearching={setChatSearching}
                            conversationSearchId={conversationSearchId}
                            activeConversation={activeConversation}
                            homeData={homeData}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;
